import React, { Component } from "react";
import { Link, Redirect } from "react-router-dom";
import Comm from "../comm/comm";
import Context from "../context/context";
import Translation from "../translation/translation";

class SettingsMenu extends Component {
    constructor() {
        super();
        if (!Comm.ValidSession()) return;

        let sid = Context.GetContext().Sid;

        let showTare1 = Comm.CallServerFunction("scales/use_tare_by_art_out", {
            session: sid
        });

        let showTare2 = Comm.CallServerFunction("scales/use_tare", {
            session: sid
        });


        this.state = {
            Translation: Translation,
            UseTare1: showTare1.use_tare,
            UseTare2: showTare2.result
        };
    }

    render() {
        if (!Comm.ValidSession()) {
            Context.Logout();
            return <Redirect to="/login" push></Redirect>;
        }

        if (Context.RenderNotOK(this.props.history)) return null;
        let self = this;

        return (
            <div className="btn-toolbar">
                <Link className="btn btn-primary menuButton" to="/articlegrouping">
                    <i className="fa fa-object-group"></i>
                    <p>{Translation.Trans("goodgrouping")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/manualresort">
                    <i className="fas fa-hand-rock"></i>
                    <p>{Translation.Trans("manualresort")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/articles">
                    <i className="fa fa-archive"></i>
                    <p>{Translation.Trans("articles")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/operators">
                    <i className="fa fa-user"></i>
                    <p>{Translation.Trans("operators")}</p>
                </Link>
                {
                    window.CONFIG.ARTICLE2OPERATOR == 1 &&
                    <Link className="btn btn-primary menuButton" to="/operator2article">
                        <i className="fa fa-user"></i>
                        <p>{Translation.Trans("operator2article")}</p>
                    </Link>
                }
                <Link className="btn btn-primary menuButton" to="/sorters">
                    <i className="fa fa-user"></i>
                    <p>{Translation.Trans("sorters")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/inout">
                    <i className="fas fa-arrows-alt-h"></i>
                    <p>{Translation.Trans("inputoutputgoods")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/articlesorters">
                    <i className="fa fa-user"></i>
                    <p>{Translation.Trans("sorter2good")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/operatorsorters">
                    <i className="fa fa-user"></i>
                    <p>{Translation.Trans("operator2sorter")}</p>
                </Link>
                <Link className="btn btn-primary menuButton" to="/editquantity">
                    <i className="fa fa-balance-scale"></i>
                    <p>{Translation.Trans("editquantities")}</p>
                </Link>
                {/* <Link className="btn btn-primary menuButton" to="/errorsort">
                    <i className="fas fa-exclamation-triangle"></i>
                    <p>{Translation.Trans("errorsort")}</p>
                </Link> */}

                <Link className="btn btn-primary menuButton" to="/user2sorter">
                    <i className="fas fa-user"></i>
                    <p>{Translation.Trans("user2sorter")}</p>
                </Link>

                {
                    self.state.UseTare1 &&
                    <Link className="btn btn-primary menuButton" to="/tare1">
                        <i className="fas fa-box"></i>
                        <p>{Translation.Trans("tare")}</p>
                    </Link>
                }

                {
                    self.state.UseTare2 &&
                    <Link className="btn btn-primary menuButton" to="/tare2">
                        <i className="fas fa-box"></i>
                        <p>{Translation.Trans("tare")}</p>
                    </Link>
                }

            </div >
        );
    }
}

export default SettingsMenu;



// WEBPACK FOOTER //
// ./src/pages/settingsmenu.js